import { useState } from "react";
import type { PaymentProvider } from "@/types/payment";

export function usePaymentMethodForm() {
  const [selectedProvider, setSelectedProvider] = useState<PaymentProvider>("mtn");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [accountType, setAccountType] = useState("individual");
  const [cryptoAddress, setCryptoAddress] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");

  const formData = {
    selectedProvider,
    phoneNumber,
    accountHolder,
    accountType,
    cryptoAddress,
    paypalEmail,
    accountNumber,
    routingNumber,
  };

  const formSetters = {
    setSelectedProvider,
    setPhoneNumber,
    setAccountHolder,
    setAccountType,
    setCryptoAddress,
    setPaypalEmail,
    setAccountNumber,
    setRoutingNumber,
  };

  return { formData, formSetters };
}